module.exports = __webpack_public_path__ + "img/Rectangle.7059944a.png";